"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const filterBoolean = ({ _eq }, value) => {
    if (_eq) {
        return ramda_1.equals(_eq, value);
    }
    return false;
};
exports.vlBooleanFilter = {
    name: "VLBooleanFilter",
    sdl: `
    input VLBooleanFilter {
      _eq: Boolean
    }
  `,
    filterFunction: filterBoolean,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9vbGVhbkZpbHRlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY21zL2ZpbHRlcnMvYm9vbGVhbkZpbHRlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBK0I7QUFPL0IsTUFBTSxhQUFhLEdBQUcsQ0FBQyxFQUFFLEdBQUcsRUFBbUIsRUFBRSxLQUFjLEVBQUUsRUFBRTtJQUNqRSxJQUFJLEdBQUcsRUFBRTtRQUNQLE9BQU8sY0FBTSxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQztLQUMzQjtJQUNELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBRVcsUUFBQSxlQUFlLEdBQTJDO0lBQ3JFLElBQUksRUFBRSxpQkFBaUI7SUFDdkIsR0FBRyxFQUFFOzs7O0dBSUo7SUFDRCxjQUFjLEVBQUUsYUFBYTtDQUM5QixDQUFDIn0=